export default "__VITE_ASSET__D9CBh6Vv__"